(function () {
  const root = document.getElementById('home-splash');
  if (!root) return;

  const logo = root.querySelector('.home-splash__logo');
  const nameEl = root.querySelector('.home-splash__name');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function dismiss() {
    root.classList.add('home-splash--hide');
    document.body.classList.remove('home-splash-pending');

    function onTransitionEnd(event) {
      if (event.propertyName !== 'opacity') return;
      root.removeEventListener('transitionend', onTransitionEnd);
      root.remove();
    }

    root.addEventListener('transitionend', onTransitionEnd);
  }

  if (reduceMotion) {
    document.body.classList.remove('home-splash-pending');
    root.remove();
    return;
  }

  setTimeout(function () {
    if (logo) logo.classList.add('is-animating');
  }, 100);

  /* Legacy old/index.html: company name fades in at 3s */
  setTimeout(function () {
    if (nameEl) nameEl.classList.add('is-visible');
  }, 3000);

  /* After name transition (2s) + small buffer, reveal the storefront */
  setTimeout(dismiss, 5500);
})();
